var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.812501 6.28125L5.8125 1.2812C6.1875 0.875 6.84375 0.875 7.21875 1.2812C7.625 1.6562 7.625 2.3125 7.21875 2.6875L3.9375 6L13.5 6C14.0625 6 14.5 6.4375 14.5 7C14.5 7.53125 14.0625 8 13.5 8L3.9375 8L7.21875 11.2812C7.625 11.6562 7.625 12.3125 7.21875 12.6875C6.84375 13.0937 6.1875 13.0937 5.8125 12.6875L0.8125 7.6875C0.4062 7.3125 0.406201 6.65625 0.812501 6.28125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.ead42c50bef90644d54d9a3ab9968cd5.svg";
export { ForwardRef as ReactComponent };